/* Component in the Scene Component to view and add the 
   Characters and BG
 * Contains the Character and CharactersAdd components
 * Contains the Background and SceneBGAdd components */
import React, { useState } from "react"
import styles from "../../../styles/Scene.module.css"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import btnStyles from "../../../styles/Button.module.css"
import { Button } from "react-bootstrap"
import Character from "./Character"
import { useEffect } from "react"
import { axiosInstance, axiosReq } from "../../../api/axiosDefaults"
import SceneBGAdd from "./SceneBGAdd"
import Background from "./Background"
import { CLIENT_PROGRAM_HOSTNAME } from "../../../utils/config"
import useHostName from "../../../hooks/useHostName"
import { useCurrentUser } from "../../../contexts/CurrentUserContext"
import NewCharacter from "./NewCharacter"
import InfoChar from "../info/InfoChar"
import SceneCharacterAdd from "./SceneCharacterAdd"

const CharactersBG = (props) => {
  const currentUser = useCurrentUser()
  const host = useHostName()
  const [showInfo, setShowInfo] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [showCharactersAdd, setShowCharactersAdd] = useState(false)
  const [showBGAdd, setShowBGAdd] = useState(false)
  const [characters, setCharacters] = useState({ results: [] })
  const [background, setBackground] = useState({ results: [] })
  const { id, setShowCharactersBG } = props

  const handleMount = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const [{ data: castdata }, { data: bgdata }] = await Promise.all([
          axiosReq.get(`/scenecharacters/?scene_id=${id}`),
          axiosReq.get(`/scenebgs/?scene_id=${id}`),
        ])
        setCharacters(castdata)
        setBackground(bgdata)
      } else {
        const [{ data: castdata }, { data: bgdata }] = await Promise.all([
          axiosInstance.get(
            `${localStorage.getItem(
              "projectSlug"
            )}/scenecharacters/?scene_id=${id}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              },
              withCredentials: true,
            }
          ),
          axiosInstance.get(
            `${localStorage.getItem("projectSlug")}/scenebgs/?scene_id=${id}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              },
              withCredentials: true,
            }
          ),
        ])
        setCharacters(castdata)
        setBackground(bgdata)
      }
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    handleMount()
    // eslint-disable-next-line
  }, [id])

  return (
    <div>
      <h5 className={`text-center mt-1 pl-5 py-1 ${styles.SubTitle}`}>
        CHARACTERS 
        <span
          className={`float-right pt-1 ${styles.Close}`}
          onClick={() => setShowCharactersBG(false)}
        >
          Close
        </span>
      </h5>
      {/* info */}
      <Row>
      <Col className="text-center mt-2" xs={12}>
      <Button
          className={`float-right px-4 py-0 ${btnStyles.Order} ${btnStyles.Button}`}
          onClick={() => setShowInfo(showInfo => !showInfo)} >INFO
      </Button> 
      </Col>
      </Row>
      {/* buttons add */}
      <div className="d-block d-md-none">
      <Row className="mb-3 mt-2">
        <Col className="text-center"  xs={6}>
        {currentUser &&
          currentUser?.groups.length > 0 &&
          (currentUser?.groups[0]?.name === "Admin" ||
            currentUser?.groups[0]?.name === "Superadmin" ||
            currentUser?.groups[0]?.name === "Admincreative") && (
              <Button
                className={`px-md-5 py-0 ${btnStyles.Shed} ${btnStyles.Button}`}
                onClick={() =>
                  setShowCharactersAdd(
                    (showCharactersAdd) => !showCharactersAdd
                  )
                }
              >
                ADD SCENE CHARS
              </Button>
          )}
      </Col>
      <Col className="text-center" xs={6}>
      {currentUser &&
          currentUser?.groups.length > 0 &&
          (currentUser?.groups[0]?.name === "Admin" ||
            currentUser?.groups[0]?.name === "Superadmin" ||
            currentUser?.groups[0]?.name === "Admincreative") && (
      <Button
          className={`py-0 px-3 px-md-5 ${btnStyles.Shed} ${btnStyles.Button}`}
          onClick={() => setShowAdd(showAdd => !showAdd)} >ADD NEW CHARS
      </Button> 
      )}
      </Col>
      </Row>
      </div>
      <div className="d-none d-md-block">
      <Row className="mb-3 mt-2 ">
        <Col className="text-center px-0"  xs={6}>
        {currentUser &&
          currentUser?.groups.length > 0 &&
          (currentUser?.groups[0]?.name === "Admin" ||
            currentUser?.groups[0]?.name === "Superadmin" ||
            currentUser?.groups[0]?.name === "Admincreative") && (
              <Button
                className={`px-md-5 py-0 ${btnStyles.Shed} ${btnStyles.Button}`}
                onClick={() =>
                  setShowCharactersAdd(
                    (showCharactersAdd) => !showCharactersAdd
                  )
                }
              >
                ADD SCENE CHARACTER
              </Button>
          )}
      </Col>
      <Col className="text-center px-0" xs={6}>
      {currentUser &&
          currentUser?.groups.length > 0 &&
          (currentUser?.groups[0]?.name === "Admin" ||
            currentUser?.groups[0]?.name === "Superadmin" ||
            currentUser?.groups[0]?.name === "Admincreative") && (
      <Button
          className={`py-0 px-md-5 ${btnStyles.Shed} ${btnStyles.Button}`}
          onClick={() => setShowAdd(showAdd => !showAdd)} >ADD NEW CHARACTERS
      </Button> 
      )}
      </Col>
      </Row>
      </div>
      {/* info */}
      <Row>
      <Col>
      {!showInfo ? (
          ""
              ) : (
                  <InfoChar  /> 
              ) } 
          </Col>
      </Row>
      {/* add new Characters */}
      <Row>
          <Col>
      {!showAdd ? (
          ""
              ) : (
                  <NewCharacter
                  setShowAdd={setShowAdd} /> 
              ) } 
          </Col>
      </Row>
      {/* add scene char*/}
      <Row>
        <Col>
          {!showCharactersAdd ? (
            ""
          ) : (
            <SceneCharacterAdd
                 id={id}
              characters={characters}
              setCharacters={setCharacters}
              setShowCharactersAdd={setShowCharactersAdd} />
          )}
        </Col>
      </Row>
      {/* titles */}
      <Row className='mt-1'>
      {/* titles */}
      <Col xs={12} sm={6} lg={4}>
      <div className='px-0 mx-3 text-center'>
      <Row >
      <Col className={`${styles.BoldTitle2} px-0 mx-0`} xs={2} ><p>#</p>
      </Col>
      <Col className='px-0 mx-0 text-center' xs={6}>
      <p className={`${styles.BoldTitle2}` }>Character</p>
      </Col>
      <Col xs={currentUser?.groups[0]?.name !== "Crew" ? 3 : 2} 
            className={` px-0 mx-0`}>
      <p className={`${styles.BoldTitle2} `}>Costume</p>
      </Col>
      {currentUser?.groups[0]?.name !== "Crew" &&
      <Col xs={1} className={`${styles.BoldTitle3} px-0 mx-0`}>
      <p ></p>
      </Col>}
      </Row>
      </div>
      </Col>
      {/* 2 */}
      <Col className='d-none d-sm-block' xs={12} sm={6} lg={4}>
      <div className='px-0 mx-3 text-center'>
      <Row >
      <Col className={`${styles.BoldTitle2} px-0 mx-0`} xs={2} ><p>#</p>
      </Col>
      <Col className='px-0 mx-0 text-center' xs={6}>
      <p className={`${styles.BoldTitle2}` }>Character</p>
      </Col>
      <Col xs={currentUser?.groups[0]?.name !== "Crew" ? 3 : 2} 
            className={` px-0 mx-0`}>
      <p className={`${styles.BoldTitle2} `}>Costume</p>
      </Col>
      {currentUser?.groups[0]?.name !== "Crew" &&
      <Col xs={1} className={`${styles.BoldTitle3} px-0 mx-0`}>
      <p ></p>
      </Col>}
      </Row>
      </div>
      </Col>
      {/* 3 */}
      <Col className='d-none d-lg-block' xs={12} sm={6} lg={4}>
      <div className='px-0 mx-3 text-center'>
      <Row >
      <Col className={`${styles.BoldTitle2} px-0 mx-0`} xs={2} ><p>#</p>
      </Col>
      <Col className='px-0 mx-0 text-center' xs={6}>
      <p className={`${styles.BoldTitle2}` }>Character</p>
      </Col>
      <Col xs={currentUser?.groups[0]?.name !== "Crew" ? 3 : 2} 
            className={` px-0 mx-0`}>
      <p className={`${styles.BoldTitle2} `}>Costume</p>
      </Col>
      {currentUser?.groups[0]?.name !== "Crew" &&
      <Col xs={1} className={`${styles.BoldTitle3} px-0 mx-0`}>
      <p ></p>
      </Col>}
      </Row>
      </div>
      </Col>
      </Row>
      {/* chars */}
      <Row className="mb-5">
        {characters.results.length
          ? characters.results.map((character, index) => (
              <Col
                key={character.id ?? character.number ?? character.name ?? index}
                xs={12}
                sm={6}
                lg={4}
                className="px-0 mx-0"
              >
                <Character
                  setCharacters={setCharacters}
                  handleMount={handleMount}
                  character={character}
                  {...character}
                />
              </Col>
            ))
          : ""}
      </Row>
      <Row>
      <Col md={{span: 8, offset: 2}} >
      <hr className="mt-2 mb-2"/>
      </Col>
      </Row>
      <Row>
      <Col  >
      <h5 style={{ textTransform: 'uppercase'}} className={`mx-5 text-center mt-2 py-0 ${styles.SubTitle }`}>
                 Background
            </h5>
      </Col>
      </Row>
      {/* BG / STANDINGS */}
      <Row>
        <Col xs={12} className="text-center mt-3">
          {currentUser &&
            currentUser?.groups.length > 0 &&
            (currentUser?.groups[0]?.name === "Admin" ||
              currentUser?.groups[0]?.name === "Superadmin" ||
              currentUser?.groups[0]?.name === "Admincreative") && (
              <Button
                className={`py-0 px-5 ${btnStyles.Shed} ${btnStyles.Button}`}
                onClick={() => setShowBGAdd((showBGAdd) => !showBGAdd)}
              >
                ADD BG / STAND-INS
              </Button>
            )}
        </Col>
      </Row>
      {/* add back */}
      <Row>
        <Col>
          {!showBGAdd ? (
            ""
          ) : (
            <SceneBGAdd
              id={id}
              background={background}
              setBackground={setBackground}
              setShowBGAdd={setShowBGAdd}
            />
          )}
        </Col>
      </Row>
      {/* back titles */}
      <Row className='mt-3' >
      {/* 1 */}
      <Col xs={12} md={6}>
      <div className='px-0 mx-3 text-center'>
      <Row >
      <Col className={`${styles.BoldTitle2} px-0 mx-0`} xs={2}><p>Qty</p>
      </Col>
      <Col className='px-0 mx-0' xs={5}>
      <p className={`${styles.BoldTitle2}` }>
      Role</p></Col>
      <Col className='px-0 mx-0' xs={currentUser?.groups[0]?.name !== "Crew" ? 4 : 5} >
      <p className={`${styles.BoldTitle2} `}>Costume</p>
      </Col>
      {
        currentUser?.groups[0]?.name !== "Crew" &&
        <Col className={`${styles.BoldTitle2} px-0 mx-0`} xs={1} >
      <p className={`${styles.BoldTitle2} `}></p>
      </Col>}
      </Row>
      </div>
      </Col>
      {/* 2 */}
      <Col className='d-none d-md-block' xs={12} md={6}>
      <div className='px-0 mx-3 text-center'>
      <Row >
      <Col className={`${styles.BoldTitle2} px-0 mx-0`} xs={2}><p>Qty</p>
      </Col>
      <Col className='px-0 mx-0' xs={5}>
      <p className={`${styles.BoldTitle2}` }>
      Role</p></Col>
      <Col className='px-0 mx-0' xs={currentUser?.groups[0]?.name !== "Crew" ? 4 : 5} >
      <p className={`${styles.BoldTitle2} `}>Costume</p>
      </Col>
      {
        currentUser?.groups[0]?.name !== "Crew" &&
        <Col className={`${styles.BoldTitle2} px-0 mx-0`} xs={1} >
      <p className={`${styles.BoldTitle2} `}></p>
      </Col>}
      </Row>
      </div>
      </Col>
      </Row>
      {/* background data */}
      <Row>
        {background.results.length
          ? background.results.map((back, index) => (
              <Col
                key={back.id ?? index}
                xs={12}
                md={6}
                className="p-0 mx-0"
              >
                <Background
                  style={{
                    backgroundColor:
                      index % 3 === 0
                        ? "#dbfaf9"
                        : index % 2 === 0
                        ? "rgb(223 254 240)"
                        : "rgb(248 241 249)",
                  }}
                  setBackground={setBackground}
                  handleMount={handleMount}
                  back={back}
                  {...back}
                />
              </Col>
            ))
          : ""}
      </Row>
      {/* break */}
      <Row className='my-5'>
      <Col xs={2} ></Col>
      <Col xs={8}>
      <hr className={`${styles.Break} mt-0 mb-0 mb-md-1`}/>
      <hr className={`${styles.BreakBlack} my-0`}/>
      </Col>
      </Row>
    </div>
  )
}

export default CharactersBG
